// extracted by mini-css-extract-plugin
export default {"form_wrap":"EditImage_form_wrap__TpVdV","image_thumb":"EditImage_image_thumb__jlw2q","radio":"EditImage_radio__OBOwD"};